import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { TabBar, Tab, TabIcon, TabIconText, TabBarScroller } from 'rmwc/Tabs'

import { Typography } from 'rmwc/Typography'

import PlacesAutocomplete from 'react-places-autocomplete'
import { geocodeByAddress, geocodeByPlaceId, getLatLng } from 'react-places-autocomplete'
import { connect } from 'react-redux'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import * as api from '../api/api'
import * as actions from '../actions'
import PersonalInfo from './PersonalInfo';
import ContactInfo from './ContactInfo';
import EducationTab from './EducationTab';
import WorkExperienceTab from './WorkExperienceTab';
import ResumeTab from './ResumeTab'

import StatusMessage from '../util/StatusMessage'

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navMenuOpen: true,
      activeTabIndex: 0,
      selectedTabIndex: 0,
      errorMsg: '',
      open: false,
      tabValueChange: false,
      userInfo: {
        accessToken: '',
        client: '',
        uid: '',
        id: '',
        role: '',
        first_name: '',
        last_name: '',
        gender_id: '',
        'dob': '',
      },
    }
    this.checkForChange = this.checkForChange.bind(this)
   }

  componentDidMount() {
    
  }

  onTabChange = evt => {
    if(!(this.state.tabValueChange)){
      this.setState({'activeTabIndex': evt.target.value, 'selectedTabIndex': evt.target.value})
    }
    else{
      this.setState({'selectedTabIndex': evt.target.value, open: true})
    }
  };

  checkForChange(evt, val) {
    this.setState({'tabValueChange': val})
  };

   onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };


  onRetainChange = evt => {
   this.setState({open:false})
  };

  onDiscardChange = evt => {
    let selTabVal = this.state.selectedTabIndex
    this.setState({'activeTabIndex': selTabVal, open:false, tabValueChange: false})
  };
  
  render() {
    
    const { open } = this.state;
    let saveChangesDialog=(
      <Dialog
        open={open}
         onClose={evt => this.setState({standardDialogOpen: false})}
      >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>Save Changes</DialogHeaderTitle>
        </DialogHeader>
        <DialogBody>
          There are UnSaved Changes. Click on Retain to remain in same Tab or Discard to discard changes and move to selected tab
        </DialogBody>
        <DialogFooter>
            <DialogFooterButton onClick={this.onRetainChange}>Retain</DialogFooterButton>
            <DialogFooterButton onClick={this.onDiscardChange}>Discard</DialogFooterButton>
            <StatusMessage error_msg = {this.state.errorMsg}/>
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
    )

    return (  
      <div className="mdc-layout-grid">
        <div className="mdc-layout-grid__inner"> 
          <div className="mdc-layout-grid__cell--span-10">
              <TabBarScroller>
                <div>
                  <TabBar
                    activeTabIndex={this.state.activeTabIndex}
                    onChange={this.onTabChange}>
                    <Tab>Basic</Tab>
                    <Tab>Contact</Tab>
                    <Tab>Education</Tab>
                    <Tab>Work Experience</Tab>
                    <Tab>Resume</Tab>
                    
                  </TabBar>
                </div>
              </TabBarScroller>
            <div className="singleColumn">
              {this.state.activeTabIndex == 0 && <PersonalInfo user={this.props.user} checkForChange={this.checkForChange}/>}
              {this.state.activeTabIndex == 1 && <ContactInfo user={this.props.user}  checkForChange={this.checkForChange}/>}
              {this.state.activeTabIndex == 2 && <EducationTab user={this.props.user} checkForChange={this.checkForChange}/>}
              {this.state.activeTabIndex == 3 && <WorkExperienceTab user={this.props.user} checkForChange={this.checkForChange}/> }
              {this.state.activeTabIndex == 4 && <ResumeTab user={this.props.user}/> }
            </div>
          </div>
          <div className="mdc-layout-grid__cell--span-2"></div>
          {saveChangesDialog}
        </div>
      </div>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/views/Profile.jsx